import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Process5713LinesService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following AngularJS service pattern exactly
  process5713Lines(
    baseUrl: string,
    params: any,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=9vmram`;

    // 🚀 CRITICAL: Build params exactly like AngularJS service
    // AngularJS service passes params directly: data: params
    // So we use the params as-is, but ensure proper encoding
    
    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

